import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import appAPI from '../../api/api'
import { ChangeHistoryRequest, ChangeHistoryResult } from '../../components/survey/common/history-card/types'

type ChangeHistoryState = {
  visible: boolean
  target: ChangeHistoryRequest | null
  history: DataLoad<ChangeHistoryResult[]>
  error: string | null
}

const getInitialHistory = (): DataLoad<ChangeHistoryResult[]> => ({
  loading: false,
  data: [],
})

const initialState: ChangeHistoryState = {
  visible: false,
  target: null,
  history: getInitialHistory(),
  error: null,
}

const fetchChangeHistory = createAsyncThunk('/fetchChangeHistory', async (payload: ChangeHistoryRequest) => {
  return await appAPI.history.getChangeHistory(payload)
})

const changeHistorySlice = createSlice({
  name: 'changeHistory',
  initialState,
  reducers: {
    openHistoryModal: (state, { payload }: PayloadAction<ChangeHistoryRequest>) => {
      state.visible = true
      state.target = payload
      state.history = getInitialHistory()
      state.error = initialState.error
    },
    closeHistoryModal: (state) => {
      state.visible = false
      state.target = null
      state.error = initialState.error
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChangeHistory.pending, (state) => {
        state.history.loading = true
        state.error = initialState.error
      })
      .addCase(fetchChangeHistory.fulfilled, (state, { payload, meta }) => {
        if (state.target?.entityType !== meta.arg.entityType || state.target?.entityId !== meta.arg.entityId) {
          return
        }

        state.history.loading = false
        state.history.data = Array.isArray(payload.data) ? payload.data : payload.data?.results || []
        state.error = initialState.error
      })
      .addCase(fetchChangeHistory.rejected, (state, { error, meta }) => {
        if (state.target?.entityType !== meta.arg.entityType || state.target?.entityId !== meta.arg.entityId) {
          return
        }

        state.history.loading = false
        state.history.data = getInitialHistory().data
        state.error = error.message || 'Не удалось загрузить историю изменений'
      })
  },
})

export default changeHistorySlice.reducer

export const changeHistoryActions = {
  ...changeHistorySlice.actions,
  fetchChangeHistory,
}
